import React, { useContext, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';

// Routes
import RootRoutes from './routes';

// Components
import Layout from './components/Layout/Layout';
import MainRouter from './components/Router';
import Modal from './components/Modal';
import { loadCountriesNationality, loadPlatforms } from './Requests';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import ScrollToTop from './components/ScrollToTop';
import Login from 'auth/pages/Login';
import { path } from './utils/path';
import { getAuthorizedModules } from 'auth/Requests';
import { Helmet } from 'react-helmet';

import {
  constants,
  getAccessTokenFromLocalStorage,
  setInLocalStorage,
} from './utils/localStorage';
import { useQuery } from 'react-query';
import ForgotPassword from 'auth/pages/ForgotPassword';
import BLocked from 'auth/pages/BLocked';
import SecondAuthentication from 'auth/pages/SecondAuthentication';
import ErrorsPage from './pages/ErrorsPage';
import ScrollToTopArrow from './components/ScrollToTopArrow';
import { useAppSettings } from './context/settings/appSettings';
import ReportStoreVersion from 'reports/pages/ReportStoreVersion';
import { getUserSettings } from 'settings/Requests';
import Loader from './components/Loader';
import ResetNewPassword from 'auth/pages/ResetNewPassword';
import { DarkModeContext } from './context/DarkModeContext';

const App = (): JSX.Element => {
  const { theme } = useAppSettings();
  // const [isDarkMode, setIsDarkMode] = useState(darkMode);
  // const darkModeToggle = () => setIsDarkMode((curr) => curr === darkMode);
  useQuery('getCountries', loadCountriesNationality, {
    enabled: !!getAccessTokenFromLocalStorage(),
  });
  useQuery('getPlatforms', loadPlatforms, {
    enabled: !!getAccessTokenFromLocalStorage(),
  });

  useQuery('getAuthorizedModules', getAuthorizedModules, {
    enabled: !!getAccessTokenFromLocalStorage(),
    onSuccess: (data: any) => {
      setInLocalStorage(constants.AUTHORIZED_MODULES, data);
    },
  });
  const { darkMode } = useContext<any>(DarkModeContext);
  const { isLoading } = useQuery(['getUserSettings'], getUserSettings, {
    onSuccess: (data: any) => {
      setInLocalStorage(constants.TIME_FORMAT, data?.date_format);
      setInLocalStorage(constants.TIME_24, data?.time_format);
      setInLocalStorage(constants.TIME_ZONE, data?.timezone);
      setInLocalStorage(
        constants.LANDING_PAGE,
        data?.landing_page?.route || '/dashboard/all',
      );
    },
    enabled: !!getAccessTokenFromLocalStorage(),
  });

  useEffect(() => {
    localStorage.removeItem(constants.IS_STORY);
  }, []);

  if (isLoading) return <Loader />;
  return (
    <>
      <Helmet>
        <title>{theme.app.title}</title>
        <style type="text/css">{`
       :root {
        --bgColor:${darkMode ? theme.colors.darkBgColor : theme.colors.bgColor};
        --bodyColor:${
          darkMode ? theme.colors.darkBodyColor : theme.colors.bodyColor
        };
        --borderColor:${
          darkMode ? theme.colors.darkBorderColor : theme.colors.borderColor
        };
        --darkBlack:${theme.colors.darkBlack};
        --errorColor:${theme.colors.errorColor};
        --lightGray:${theme.colors.lightGray};
        --mainColor:${
          darkMode ? theme.colors.darkMainColor : theme.colors.mainColor
        };
        --errorBoundBgColor:${
          darkMode ? theme.colors.darkErrorColor : theme.colors.lightErrorColor
        };
        --mainColorRGB:${theme.colors.mainColorRGB};
        --negativeColor:${theme.colors.negativeColor};
        --negativeColorRGB:${theme.colors.negativeColorRGB};
        --neutralColor:${theme.colors.neutralColor};
        --neutralColorRGB:${theme.colors.neutralColorRGB};
        --positiveColor:${theme.colors.positiveColor};
        --positiveColorRGB:${theme.colors.positiveColorRGB};
        --secondaryColorRGB:${theme.colors.secondaryColorRGB};
        --tweetTextColor:${
          darkMode ? theme.colors.bgColor : theme.colors.lightTweetTextColor
        };
        --tweetSubTitleColor:${
          darkMode
            ? theme.colors.darkTweetSubTitleColor
            : theme.colors.lightTweetSubTitleColor
        };
        --disabledLabel:${
          darkMode
            ? theme.colors.darkDisabledColor
            : theme.colors.lightDisabledColor
        };
        --disabledDatePicker:${
          darkMode
            ? theme.colors.darkDisabledDatePicker
            : theme.colors.lightDisabledDatePicker
        };
        --secondaryColor:${
          darkMode
            ? theme.colors.darkSecondaryColor
            : theme.colors.secondaryColor
        };
        --instagramColor:${
          darkMode
            ? theme.colors.lightInstagramColor
            : theme.colors.lightInstagramColor
        };

       }
    `}</style>
      </Helmet>
      <Modal />
      <ToastContainer
        position="top-center"
        autoClose={3500}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        hideProgressBar
        closeButton={false}
        icon={false}
      />

      <ScrollToTop />
      <Switch>
        <Route path={path.auth.SIGN_IN} component={Login} />
        <Route path={path.auth.FORGOT_PASSWORD} component={ForgotPassword} />
        <Route path={path.auth.BLOCKED} component={BLocked} />
        <Route
          path={path.auth.SECOND_AUTHENTICATION}
          component={SecondAuthentication}
        />
        <Route
          path={path.reports.REPORT_STORE_VERSION_URL}
          component={ReportStoreVersion}
        />
        <Route
          path={path.auth.RESET_NEW_PASSWORD}
          component={ResetNewPassword}
        />
        <Route
          path={path.auth.SECOND_AUTHENTICATION}
          component={SecondAuthentication}
        />

        {/*
            <Route
              path={path.auth.FORGOT_PASSWORD}
              component={ForgotPassword}
            />
            <Route path={path.auth.BLOCKED} component={Block} /> */}
        {/* <Route  component={Login} /> */}
        <Layout>
          <MainRouter routes={RootRoutes} />
        </Layout>
        <Route path="*">
          <ErrorsPage />
        </Route>
      </Switch>

      <ScrollToTopArrow />
    </>
  );
};

export default App;
